class Hotspot extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.tooltip = this.querySelector('[role="tooltip"]');
    this.handleEnter = this.handleEnter.bind(this);
    this.handleLeave = this.handleLeave.bind(this);
    this.handleFocusIn = this.handleFocusIn.bind(this);
    this.handleFocusOut = this.handleFocusOut.bind(this);
    /** @type {NodeListOf<HTMLElement>} */
    this.staggeredElements = this.querySelectorAll(".staggered-element");
    this.focusableElements = this.querySelectorAll("a");
  }

  connectedCallback() {
    if (!this.button || !this.tooltip) return;

    this.button.addEventListener("mouseenter", this.handleEnter);
    this.addEventListener("mouseleave", this.handleLeave);

    this.addEventListener("focusin", this.handleFocusIn);
    this.addEventListener("focusout", this.handleFocusOut);
  }

  disconnectedCallback() {
    if (!this.button || !this.tooltip) return;

    this.button.removeEventListener("mouseenter", this.handleEnter);
    this.removeEventListener("mouseleave", this.handleLeave);

    this.removeEventListener("focusin", this.handleFocusIn);
    this.removeEventListener("focusout", this.handleFocusOut);
  }

  handleEnter() {
    this.show();
  }

  handleLeave() {
    this.hide();
  }

  handleFocusIn() {
    this.show();
  }
  
  /**
   * @param {FocusEvent} event
   */
  handleFocusOut(event) {
    const nextFocus = /** @type {HTMLElement|null} */ (event.relatedTarget);
    if (nextFocus && this.contains(nextFocus)) {
      return;
    }
    this.hide();
  }

  show() {
    this.classList.add("is-active");

    if (this.staggeredElements.length) {
      this.staggeredElements.forEach((li, i) => {
        li.style.transitionDelay = `${i * 0.15}s`;
      });
    }

    if (this.focusableElements.length) {
      this.focusableElements.forEach((el) => el.removeAttribute("tabindex"));
    }
  }

  hide() {
    this.classList.remove("is-active");

    if (this.staggeredElements.length) {
      this.staggeredElements.forEach((li) => {
        li.style.transitionDelay = "0s";
      });
    }

    if (this.focusableElements.length) {
      this.focusableElements.forEach((el) => el.setAttribute("tabindex", "-1"));
    }
  }
}

if (!customElements.get("hotspot-element")) {
  customElements.define("hotspot-element", Hotspot);
}
